<template>
    <div class="instructions">
        <div class="instructions__top-container">
            <span class="instructions__close-btn">
                <img
                    src="@/assets/close.svg"
                    alt=""
                    @click="handleClosePopup"
                />
            </span>
            <img src="@/assets/ok2.svg" alt="ok" class="instructions__icon" />
            <p class="instructions__text-ok">
                {{ $t(`${TRANSLATION_KEY}.goodExample`) }}
            </p>
            <img
                v-if="UtilityHelper.getLocale() == Locale.PL"
                src="@/assets/upload-instructions/pl/idOk1.png"
                alt="ok"
                class="instructions__example"
            />
            <img
                v-else
                src="@/assets/upload-instructions/en/idOk1.png"
                alt="ok"
                class="instructions__example"
            />
        </div>
        <div>
            <div class="instructions__bad-examples">
                <img
                    src="@/assets/bad.svg"
                    alt="ok"
                    class="instructions__icon"
                />
                <p class="instructions__text-bad">
                    {{ $t(`${TRANSLATION_KEY}.badExample`) }}
                </p>
                <div ref="swiper" class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <img
                                v-if="UtilityHelper.getLocale() == Locale.PL"
                                src="@/assets/upload-instructions/pl/idBad1.png"
                                alt="ok"
                                class="instructions__example"
                            />
                            <img
                                v-else
                                src="@/assets/upload-instructions/en/idBad1.png"
                                alt="ok"
                                class="instructions__example"
                            />
                            <h3 class="slide-title">
                                {{ $t(`${TRANSLATION_KEY}.slideTitle1`) }}
                            </h3>
                            <p class="slide-text">
                                {{ $t(`${TRANSLATION_KEY}.slideText1`) }}
                            </p>
                        </div>
                        <div class="swiper-slide">
                            <img
                                v-if="UtilityHelper.getLocale() == Locale.PL"
                                src="@/assets/upload-instructions/pl/idBad2.png"
                                alt="ok"
                                class="instructions__example"
                            />
                            <img
                                v-else
                                src="@/assets/upload-instructions/en/idBad2.png"
                                alt="ok"
                                class="instructions__example"
                            />
                            <h3 class="slide-title">
                                {{ $t(`${TRANSLATION_KEY}.slideTitle2`) }}
                            </h3>
                            <p class="slide-text">
                                {{ $t(`${TRANSLATION_KEY}.slideText2`) }}
                            </p>
                        </div>
                        <div class="swiper-slide">
                            <img
                                v-if="UtilityHelper.getLocale() == Locale.PL"
                                src="@/assets/upload-instructions/pl/idBad3.png"
                                alt="ok"
                                class="instructions__example"
                            />
                            <img
                                v-else
                                src="@/assets/upload-instructions/en/idBad3.png"
                                alt="ok"
                                class="instructions__example"
                            />
                            <h3 class="slide-title">
                                {{ $t(`${TRANSLATION_KEY}.slideTitle3`) }}
                            </h3>
                            <p class="slide-text">
                                {{ $t(`${TRANSLATION_KEY}.slideText3`) }}
                            </p>
                        </div>
                    </div>
                    <div class="swiper-pagination" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { UtilityHelper } from '@/helpers/UtilityHelper';
import { useStore } from 'vuex';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { Locale } from '@/constants/locale';

export default defineComponent({
    name: 'UploadInstructions',
    setup() {
        const store = useStore();

        const swiper = ref<HTMLElement | null>(null);

        const TRANSLATION_KEY = 'steps.HowToTakePicture';

        const handleClosePopup = () => {
            store.state.showInstructionPopup =
                !store.state.showInstructionPopup;
            window.scrollTo(0, 0);
        };

        onMounted(() => {
            setTimeout(() => {
                if (swiper.value) {
                    new Swiper(swiper.value, {
                        slidesPerView: 1.3,
                        spaceBetween: 20,
                        centeredSlides: true,
                        pagination: {
                            el: '.swiper-pagination',
                        },
                    });
                }
            }, 0);
        });

        return {
            TRANSLATION_KEY,
            handleClosePopup,
            UtilityHelper,
            Locale,
        };
    },
});
</script>

<style lang="scss" scoped>
.instructions {
    padding: 30px 0 30px 20px;
    border: 1px solid #dddee3;
    position: absolute;
    max-width: 440px;
    width: 100%;
    overflow: hidden;
    top: 0;
    background-color: #ffffff;
    z-index: 11;

    &__top-container {
        padding-right: 20px;

        .instructions__example {
            max-width: 286px;
            display: block;
            margin: 0 auto 20px;
        }

        .instructions__icon {
            margin-top: -18px;
        }
    }

    &__icon {
        display: block;
        margin: 0 auto 10px auto;
        position: relative;
        z-index: 1;
    }

    &__text-ok,
    &__text-bad {
        font-size: 16px;
        font-weight: 700;
        text-align: center;
        margin-bottom: 20px;
    }

    &__text-ok {
        color: #339d36;
    }

    &__text-bad {
        color: #af1919;
        margin-bottom: 30px;
        position: relative;
        z-index: 1;
    }

    &__example {
        margin-bottom: 20px;
    }

    &__description {
        font-size: 14px;
        text-align: center;
        margin: 0 auto 20px auto;
    }

    &__bad-examples {
        background: #ffeded;
        margin-bottom: 25px;
        padding: 20px 0;
        position: relative;
        z-index: 1;

        &::after {
            content: '';
            position: absolute;
            background: #ffeded;
            top: 0;
            left: -20px;
            height: 100%;
            width: 318px;

            @media (min-width: 500px) {
                width: 420px;
            }
        }
    }

    &__close-btn {
        display: flex;
        justify-content: flex-end;

        img {
            cursor: pointer;
        }
    }

    .slide-title {
        font-size: 16px;
        margin: 0 auto;
        text-align: center;
        font-weight: 600;
    }

    .slide-text {
        font-size: 14px;
        text-align: center;
    }

    .swiper-wrapper {
        margin-bottom: 50px;
    }

    .swiper-pagination-bullet {
        background: #fff;
        opacity: 1;
        margin: 0 10px;

        &.swiper-pagination-bullet-active {
            background: 00214a;
        }
    }

    .picture-number {
        font-size: 25px;
        font-weight: 600;
        color: #d9d9d9;
        display: block;
        text-align: center;
        margin-bottom: 20px;

        span {
            color: #1a2242;
        }

        &--back {
            color: #1a2242;
        }
    }

    .picture-quality-img {
        display: block;
        margin: 0 auto 30px auto;
    }

    .picture-quality-text {
        color: 00214a;
        text-align: center;
        font-size: 16px;
        margin-bottom: 0;
        line-height: 19px;
    }
}
</style>
